import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import { store } from "./store";
import "./index.css";
import "./App.css";
import { Provider } from "react-redux";
import type { SeEnvironment, SeVaporOptions } from "@/types";

type InitOptions = {
    mountId?: string;
    apiKey: string;
    environment?: SeEnvironment;
    seVaporOptions?: SeVaporOptions;
};

function init(options: InitOptions) {
    const {
        mountId = "se-vapor-mount",
        apiKey,
        environment,
        seVaporOptions,
    } = options;

    const mountNode = document.getElementById(mountId);

    if (!mountNode) {
        console.error(`Mount node with id "" not found.`);
        return;
    }

    mountNode.classList.add("se-vapor");

    createRoot(mountNode!).render(
        <StrictMode>
            <Provider store={store}>
                <App
                    apiKey={apiKey}
                    environment={environment}
                    options={seVaporOptions}
                />
            </Provider>
        </StrictMode>,
    );
}

// Expose the init function globally
if (typeof window !== "undefined") {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).SeVapor = { init };
}
